var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 158,
    viewBox: "0 0 143 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.15 157.88C2.35 157.88 0.07 155.65 0 152.86V152.73C0 152.73 0 88.75 0 67.42C0 50.12 7.81 0 71.47 0C135.13 0 142.94 49.47 142.94 67.42C142.94 88.68 142.94 152.48 142.94 152.48V152.62C142.86 155.54 140.47 157.89 137.53 157.89H5.15V157.88ZM71.47 17.83C56.81 17.83 46.91 21.29 40.08 25.61C33.17 29.97 28.38 35.86 25 42.15C21.58 48.52 19.73 55.09 18.77 60.19C18.3 62.7 18.06 64.75 17.94 66.1C17.88 66.77 17.85 67.26 17.84 67.53C17.84 67.59 17.84 67.64 17.84 67.68V140.04H125.11V67.68C125.11 67.68 125.11 67.59 125.11 67.53C125.1 67.26 125.07 66.77 125.01 66.1C124.89 64.75 124.65 62.7 124.18 60.19C123.22 55.09 121.38 48.52 117.95 42.15C114.57 35.86 109.78 29.98 102.87 25.61C96.04 21.3 86.14 17.83 71.48 17.83H71.47Z",
    fill: "#FFE916"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiNew);
export default __webpack_public_path__ + "static/media/archi-new.8963b7c6.svg";
export { ForwardRef as ReactComponent };